import { render } from "./AdminNavbar.vue?vue&type=template&id=d9ecbbf6"
import script from "./AdminNavbar.vue?vue&type=script&lang=js"
export * from "./AdminNavbar.vue?vue&type=script&lang=js"
script.render = render

export default script